
import { EpimsBaseEntityDto } from './epim-base.dto';
export class FacilityRegisterHostDto extends EpimsBaseEntityDto {

   FacilityRegistrationId: string;
   LandTitleId: string;
   Remarks: string;


}




